import { XMarkIcon } from '@heroicons/react/16/solid';
import { Modal, ModalBody, ModalHeader, SIZE } from 'baseui/modal';
import { HeadingMedium, HeadingXSmall, LabelSmall } from 'baseui/typography';
import { TFunction } from 'i18next';
import { Icon } from 'leaflet';
import { MapContainer, Marker } from 'react-leaflet';
import { TILES } from './constants';
import MapTilesMenu from './map-tiles-menu';

/* eslint-disable @typescript-eslint/no-explicit-any */
type DynamicObject = {
  [name: string]: any;
};

type TModal = {
  t: TFunction;
  data:
    | {
        latitude: number;
        longitude: number;
        name: string;
        address: string;
      }
    | DynamicObject;
  isOpen: boolean;
  onClose: () => void;
};

const pointerIcon = new Icon({
  iconUrl:
    'https://s3.ap-southeast-1.amazonaws.com/waresix.com/assets/navi/images/MapPin.svg',
  iconSize: [38, 38], // size of the icon
  popupAnchor: [-3, -76], // point from which the popup should open relative to the iconAnchor
});

export default function ModalPreviewLocation({
  t,
  data,
  isOpen,
  onClose,
}: TModal) {
  return (
    <Modal size={SIZE.auto} closeable={false} autoFocus={false} isOpen={isOpen}>
      <ModalHeader>
        <div className="flex justify-between">
          <HeadingMedium>{t('preview_location')}</HeadingMedium>
          <XMarkIcon
            className="w-6 h-6 mt-2 cursor-pointer"
            color="#000000"
            onClick={() => onClose()}
          />
        </div>
      </ModalHeader>
      <ModalBody>
        <HeadingXSmall className="mt-10 mb-4">
          {t('location_point')}
        </HeadingXSmall>
        <div className="border rounded-b-lg border-[#E8E8E8]">
          {isOpen ? (
            <MapContainer
              className="md:!w-[600px] !w-[368px] !h-[315px]"
              markerZoomAnimation={true}
              zoomAnimation={true}
              fadeAnimation={true}
              center={[data?.latitude, data?.longitude]}
              zoom={30}
            >
              <MapTilesMenu listTiles={[TILES.OSM_LIGHT, TILES.OSM_STANDARD]} />
              <Marker
                position={[data?.latitude, data?.longitude]}
                icon={pointerIcon}
              ></Marker>
            </MapContainer>
          ) : null}
          <div className="flex p-4 border-t border-[#E8E8E8] md:w-[600px] w-[368px]">
            <div className="flex-wrap">
              <LabelSmall>
                {data?.name}
                <span className="font-normal">{`: ${data?.address}`}</span>
              </LabelSmall>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
}
